<template>
  <header>
    <app-skeleton-text class="mb-3" :height="22" width="30%" />
    <app-skeleton-paragraph class="w-[30%]" :lines="3" />
  </header>
</template>
